import {
  ButtonV3,
  type ButtonV3Props,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

interface SizeGuideModalStepCtaProps extends Omit<ButtonV3Props, 'children'> {
  readonly label: MessageKey;
}

export interface SizeGuideModalStepProps {
  readonly content: MessageKey[];
  readonly cta?: SizeGuideModalStepCtaProps;
  readonly index: number;
  readonly title: MessageKey;
}

const SizingGuideModalStepCta = ({
  label,
  ...props
}: SizeGuideModalStepCtaProps) => {
  const t = useTranslations();

  return (
    <ButtonV3 className="mt-5" data-cy="size-guide-modal-step-cta" {...props}>
      {t.rich(label)}
    </ButtonV3>
  );
};

const SizeGuideModalStep = ({
  content,
  cta,
  index,
  title,
}: SizeGuideModalStepProps): JSX.Element => {
  const t = useTranslations();

  return (
    <li className="mb-12 last:mb-0" data-cy="size-guide-modal-step">
      <TypographyV3
        className="mb-5 text-heading-lg leading-tighter"
        data-cy="size-guide-modal-step-title"
        Element="h3"
        weight="light"
      >
        <span aria-hidden="true" className="mr-3 inline-block">
          {index + 1}.
        </span>
        <span>{t.rich(title)}</span>
      </TypographyV3>
      {content.map((key) => (
        <TypographyV3
          className="text-sm"
          data-cy="size-guide-modal-step-content"
          key={key}
        >
          {t.rich(key)}
        </TypographyV3>
      ))}
      {cta && <SizingGuideModalStepCta {...cta} />}
    </li>
  );
};

export default SizeGuideModalStep;
